import { isString } from "lodash";

/** API/yup item in `IApiError.validationErrors` (plain object with string `message`). */
export type TApiSerializedValidationErrorItem = {
  path?: string;
  name?: string;
  message: string;
};

export const isApiSerializedValidationErrorItem = (
  value: unknown,
): value is TApiSerializedValidationErrorItem => {
  if (typeof value !== "object" || value === null || !("message" in value)) {
    return false;
  }

  return isString((value as { message: unknown }).message);
};

export const joinApiSerializedValidationErrorMessages = (
  items: readonly unknown[] | undefined,
  separator = ", ",
): string =>
  (
    items?.filter(isApiSerializedValidationErrorItem).map(e => e.message) ?? []
  ).join(separator);
